import React from 'react';
import { VbzDivider, VbzButton } from '@smiles/voebiz-ui-kit';
export default function RecoverComponentMobile({
  imageFooter,
  buttonText,
}: {
  imageFooter: string;
  buttonText: string;
}) {
  return (
    <>
      <div className="divider-footer">
        <VbzDivider height="medium"></VbzDivider>
      </div>
      <div className="footer-hyperlink">
        <p className="label-hyperlink">Ainda não é cliente VoeBiz?</p>
        <div className="create-account-button">
          <VbzButton
            color="hyperlink"
            type="button"
            text={buttonText}
            onClick={() => {
              window.location.href = '/cadastro';
            }}
          />
          <span className="material-icons" style={{ position: 'relative', right: '100px' }}>
            keyboard_arrow_right
          </span>
        </div>
      </div>
      <div className="footer-group">
        <p className="label-footer-group">Clientes VoeBiz voam com:</p>
        <img src={imageFooter} />
      </div>
    </>
  );
}
